module.exports = __webpack_public_path__ + "img/installation.eb22b62e.jpg";